#import "../fragments/domain-fragment.graphql"

mutation CreateDomain($domain: DomainCreateInput!) {
    domainCreate(input: $domain) {
        domain {
            ...DomainFragment
        }
    }
}
